import { configureStore } from '@reduxjs/toolkit';
import cartReducer from './cart';
import errorReducer from './error';
import userReducer from './user';

export const store = configureStore({
    reducer: {
        cart: cartReducer,
        error: errorReducer,
        user: userReducer
    }
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;